import { useBrand } from "@/lib/brand";
import { fileUrl } from "@/lib/api";

export const Logo = ({ className = "", testId = "site-logo" }) => {
  const { settings } = useBrand();
  const src = settings?.logo_path ? fileUrl(settings.logo_path) : "/img/smartkey-logo.png";
  return <img data-testid={testId} src={src} alt={`${settings?.company_name || "Smartkey"} of Boston logo`} className={`h-[68px] w-auto max-w-[260px] object-contain md:h-[100px] md:max-w-[380px] ${className}`} />;
};
